import { EnumModuloDTONecessitaFirma } from '@framework/api-client';
import { IModuleDelegation } from '@framework/frontoffice-submission';
import { getModuleTitle } from '@framework/frontoffice-submission/src/module/getModuleTitle';
import { t } from '@framework/i18n';
import { Space } from 'antd';
import { ColumnGroupType, ColumnType } from 'antd/es/table';
import React from 'react';
import { DelegationTypeUserTag } from './components/DelegationTypeUserTag';
import { ModuleListName } from './components/ModuleListName';

export const delegationColumnBase: Record<
  string,
  ColumnGroupType<IModuleDelegation> | ColumnType<IModuleDelegation>
> = {
  module: {
    title: t('delegation-column-base.moduli', 'Moduli'),
    key: 'submissionModule',
    render: (_, record) => (
      <ModuleListName
        name={getModuleTitle(record.submissionModule)}
        shouldSign={
          record.submissionModule.modulo?.modulo?.necessitaFirma !=
          EnumModuloDTONecessitaFirma.NO
        }
      />
    ),
  },
  delegates: {
    title: t('delegation-column-base.delegati', 'Delegati'),
    key: 'delegates',
    width: 250,
    render: (_, record) => (
      <Space wrap size={[0, 4]}>
        {record.compilation && (
          <DelegationTypeUserTag delegate={record.compilation} />
        )}
        {record.sign && <DelegationTypeUserTag delegate={record.sign} />}
      </Space>
    ),
  },
  viewers: {
    title: t('delegation-column-base.lettura', 'Lettura'),
    key: 'viewers',
    render: (_, record) => (
      <Space wrap size={[0, 4]}>
        {record.view.map(v => (
          <DelegationTypeUserTag delegate={v} key={v.fiscalCode} />
        ))}
      </Space>
    ),
  },
};

export const delegationColumns = [
  delegationColumnBase.module,
  delegationColumnBase.delegates,
  delegationColumnBase.viewers,
];
